module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-PW-Australia-1-Landing-Page.70c1c76e.webp";